<div class="tlo-olb-upload p-3">
    <!-- Header with Pending tags -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex gap-2">
            <span class="badge rounded-pill" [ngClass]="hasTloData() ? 'badge-success' : 'badge-pending'">
                TLO {{hasTloData() ? 'selected' : 'pending'}}
            </span>
            <span class="badge rounded-pill" [ngClass]="hasOlbData() ? 'badge-success' : 'badge-pending'">
                OLB {{hasOlbData() ? 'selected' : 'pending'}}
            </span>
        </div>
        <div class="text-muted fs-13 fw-500">
            {{ (hasTloData() ? 1 : 0) + (hasOlbData() ? 1 : 0) }} of 2 files selected
        </div>
    </div>

    <hr class="mb-4 mt-0 text-muted" style="opacity: 0.15;">

    <!-- Upload Row -->
    <div class="row gx-4 mb-4 justify-content-center">
        <!-- TLO Column -->
        <div class="col-md-6 mb-3 mb-md-0">
            <div class="d-flex align-items-center mb-3">
                <div class="circle-number me-2">1</div>
                <div>
                    <div class="fs-15 fw-600 text-dark">TLO File</div>
                    <div class="fs-13 text-secondary">Upload TLO file</div>
                </div>
            </div>

            <div *ngIf="!hasTloData()" class="dropzone d-flex flex-column align-items-center justify-content-center text-center" [class.drag-over]="isTloDragOver"
                (dragover)="onTloDragOver($event)" (dragleave)="onTloDragLeave($event)" (drop)="onTloDrop($event)"
                (click)="triggerTloFileInput()">
                <div class="upload-icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-secondary"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                </div>
                <div class="fs-14 fw-500 text-secondary mb-1 mt-2">Click to choose or drag & drop</div>
                <div class="fs-12 text-muted mt-2">.csv, .xlsx</div>
                <input type="file" #fileInput (change)="onFileSelected($event)" accept=".csv,.xlsx,.json" class="d-none">
            </div>

            <div *ngIf="hasTloData()" class="file-pill d-flex flex-column align-items-center justify-content-center text-center position-relative cursor-pointer" [class.drag-over]="isTloDragOver"
                (dragover)="onTloDragOver($event)" (dragleave)="onTloDragLeave($event)" (drop)="onTloDrop($event)" (click)="triggerTloFileInput()">
                <button type="button" class="btn-remove position-absolute top-0 end-0 m-2 mt-2 me-2 shadow-sm" (click)="removeFile(); $event.stopPropagation()" aria-label="Remove TLO file">&times;</button>
                <div class="file-pill-icon mb-2 shadow-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                </div>
                <div class="fs-14 fw-600 text-truncate px-3 w-100" [title]="tloFileName">{{ tloFileName || 'TLO file uploaded' }}</div>
                <div class="fs-12 text-success mt-1 fw-500">Ready to upload</div>
            </div>
        </div>

        <!-- OLB Column -->
        <div class="col-md-6">
            <div class="d-flex align-items-center mb-3">
                <div class="circle-number me-2">2</div>
                <div>
                    <div class="fs-15 fw-600 text-dark">OLB File</div>
                    <div class="fs-13 text-secondary">Upload OLB file</div>
                </div>
            </div>

            <div *ngIf="!hasOlbData()" class="dropzone d-flex flex-column align-items-center justify-content-center text-center" [class.drag-over]="isOlbDragOver"
                (dragover)="onOlbDragOver($event)" (dragleave)="onOlbDragLeave($event)" (drop)="onOlbDrop($event)"
                (click)="triggerOlbFileInput()">
                <div class="upload-icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-secondary"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                </div>
                <div class="fs-14 fw-500 text-secondary mb-1 mt-2">Click to choose or drag & drop</div>
                <div class="fs-12 text-muted mt-2">.csv, .xlsx</div>
                <input type="file" #olbFileInput (change)="onOlbFileSelected($event)" accept=".csv,.xlsx,.json" class="d-none">
            </div>

            <div *ngIf="hasOlbData()" class="file-pill d-flex flex-column align-items-center justify-content-center text-center position-relative cursor-pointer" [class.drag-over]="isOlbDragOver"
                (dragover)="onOlbDragOver($event)" (dragleave)="onOlbDragLeave($event)" (drop)="onOlbDrop($event)" (click)="triggerOlbFileInput()">
                <button type="button" class="btn-remove position-absolute top-0 end-0 m-2 mt-2 me-2 shadow-sm" (click)="removeOlbFile(); $event.stopPropagation()" aria-label="Remove OLB file">&times;</button>
                <div class="file-pill-icon mb-2 shadow-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                </div>
                <div class="fs-14 fw-600 text-truncate px-3 w-100" [title]="olbFileName">{{ olbFileName || 'OLB file uploaded' }}</div>
                <div class="fs-12 text-success mt-1 fw-500">Ready to upload</div>
            </div>
        </div>
    </div>

    <hr class="mb-4 mt-0 text-muted" style="opacity: 0.15;">

    <!-- Notes -->
    <div class="form-group mb-4">
        <label class="fs-14 fw-600 mb-2">Notes <span class="text-muted fw-normal">(required)</span></label>
        <textarea class="form-control" [(ngModel)]="notes" placeholder="Add context about this upload batch..." rows="3"></textarea>
    </div>

    <!-- Footer -->
    <div class="d-flex justify-content-end align-items-center mt-3 footer-actions">
        <button type="button" class="btn btn-link text-secondary fw-600 me-2" (click)="cancel()"
            [disabled]="dataSubmitted">Cancel</button>
        <button type="button" class="btn btn-primary px-4 fw-700" (click)="submitFile()"
            [disabled]="dataSubmitted">Add</button>
    </div>
</div>
